import React from "react"

const SectionTrust = () => (
  <section className="leadsec alt">
    <div className="wrap">
      <h2>Why the field trusts us</h2>
      <div className="lead2">
        <div className="l2-card">
          <span className="l2-kicker">
            Bundled Payment and Care Transformation Summit
          </span>
          <h3>We host the nation’s only bundled payment summit</h3>
          <p>
            <b>Sacha Wolf of the CMS Innovation Center</b>, who works on both
            CJR-X and TEAM, gave her first public talk on CJR-X at our 8th
            Summit in August 2026.
          </p>
          <div className="l2-links">
            <a
              className="art-row"
              href="https://summit.avantgardehealth.com/"
              target="_blank"
              rel="noopener"
            >
              <span className="l2-ic">
                <svg
                  viewBox="0 0 32 32"
                  aria-hidden="true"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="5" y="7" width="22" height="20" rx="3" />
                  <path d="M5 13h22M11 4v6M21 4v6" />
                  <path d="M11 18h3M18 18h3M11 22h3" />
                </svg>
              </span>
              <span className="art-t">Explore the Summit</span>
              <span className="art-go">
                <svg viewBox="0 0 16 16" aria-hidden="true">
                  <path
                    d="M6 3h7v7M13 3L5 11"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </a>{" "}
            <a
              className="art-row"
              href="https://resources.avantgardehealth.com"
              target="_blank"
              rel="noopener"
            >
              <span className="l2-ic play">
                <svg viewBox="0 0 32 32" aria-hidden="true">
                  <path d="M12 9.5v13l11-6.5z" fill="currentColor" />
                </svg>
              </span>
              <span className="art-t">
                Request access to session recordings
              </span>
              <span className="art-go">
                <svg viewBox="0 0 16 16" aria-hidden="true">
                  <path
                    d="M6 3h7v7M13 3L5 11"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </a>
          </div>
        </div>
        <div className="l2-card">
          <span className="l2-kicker">Published research</span>
          <h3>
            The only company published in Harvard Business Review on bundled
            payments
          </h3>
          <div className="l2-links">
            <a
              className="art-row"
              href="https://pubmed.ncbi.nlm.nih.gov/31157819/"
              target="_blank"
              rel="noopener"
            >
              <span className="art-j jama">JAMA</span>
              <span className="art-t">
                Economic and Clinical Outcomes Under CMS Mandatory Bundled
                Payments for Joint Replacements
              </span>
              <span className="art-go">
                <svg viewBox="0 0 16 16" aria-hidden="true">
                  <path
                    d="M6 3h7v7M13 3L5 11"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </a>
            <a
              className="art-row"
              href="https://hbr.org/2015/10/getting-bundled-payments-right-in-health-care"
              target="_blank"
              rel="noopener"
            >
              <span className="art-j hbr">HBR</span>
              <span className="art-t">
                Getting Bundled Payments Right in Health Care
              </span>
              <span className="art-go">
                <svg viewBox="0 0 16 16" aria-hidden="true">
                  <path
                    d="M6 3h7v7M13 3L5 11"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </a>
            <a
              className="art-row"
              href="https://hbr.org/2024/10/physicians-can-help-cut-costs-they-just-need-the-right-incentives"
              target="_blank"
              rel="noopener"
            >
              <span className="art-j hbr">HBR</span>
              <span className="art-t">
                Physicians Can Help Cut Costs. They Just Need the Right
                Incentives.
              </span>
              <span className="art-go">
                <svg viewBox="0 0 16 16" aria-hidden="true">
                  <path
                    d="M6 3h7v7M13 3L5 11"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </a>
          </div>
          <p className="pdfnote">
            Would you like a PDF copy of an article?{" "}
            <a href="mailto:derek@avantgardehealth.com?subject=Article%20PDF%20request">
              Email Derek Haas
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  </section>
)

export default SectionTrust
